import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import { useAppSelector, useAppDispatch, type AppRootState } from '@/configureStore';
import { selectDisplayTax, setPreference } from '@/stores/preferences';
import styles from './ToggleTax.module.scss';

export const ToggleTax = () => {
  const { t } = useTranslation('header');

  const dispatch = useAppDispatch();
  const displayTax: boolean = useAppSelector((state: AppRootState) => selectDisplayTax(state));

  const toggleDispayTax = () =>
    dispatch(
      setPreference({
        displayTax: !displayTax
      })
    );

  return (
    <div className={styles.toggleTax}>
      <label className={styles.toggleTaxLabel}>
        <input type="checkbox" className={styles.toggleTaxInput} onChange={toggleDispayTax} checked={displayTax} />
        <span className="ml-2 d-sm-none">{t('show-prices-inc-tax-short')}</span>
        <span className="ml-2 d-none d-sm-inline">{t('show-prices-inc-tax')}</span>
      </label>
    </div>
  );
};
